import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import './ugiPipelinesPage.scss';

import pipelines_distribution from './assets/pipelines_distribution_2x.jpg';
import pipelines_transmission from './assets/pipelines_transmission_2x.jpg';
import ui_pipelines from './assets/ui_pipelines_2x.jpg';

import pipelines_circle from './assets/pipelines_circle_2x.png';

import pipelines_leak from './assets/pipelines_leak_recognition_2x.png';
import pipelines_leak_response from'./assets/pipelines_leak_response_2x.png';
import {Helmet} from 'react-helmet';
/**
 * The UgiPipelinesPage component.
 *
 * @constructor
 */
export class UgiPipelinesPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="ugi-pipelines-page" className="system-page">
           <Helmet>
             <title>Pipelines - NEI</title>
             <meta name = "description" content ="An underground network of pipelines transport energy resources such as natural gas, crude oil and other refined products over long and short distance." />
           </Helmet>
        <div className="container-fluid">
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="content container">
                  <div className="row">
                    <div className="col">
                      <p className="last">An underground network of more than 3.3 million miles of plastic, composite, steel and cast iron, pipelines transport energy resources such as natural gas, crude oil and other refined products over long and short distance. Typically this is from areas of production to refining and storage centers to distribution points and end-users such as homes, businesses and other industrial users. Pipelines are the safest, most efficient and economical way of reliably transporting energy resources.</p>
                      <h1>Types of Pipelines</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="container thumbnail-container">
              <div className="row">
                <div className="col col-12 col-lg-4">
                  <div className="thumbnail">
                    <img src={ui_pipelines} alt="Pipelines"/>
                    <div className="text">
                      <h2>Gathering</h2>
                      <p>Collect oil and gas from areas of production</p>
                    </div>
                  </div>
                </div>
                <div className="col col-12 col-lg-4">
                  <div className="thumbnail">
                    <img src={pipelines_transmission} alt="Transmission" />
                    <div className="text">
                      <h2>Transmission</h2>
                      <p>Transport materials to and from storage, refining facilities, manufacturing centers and places of distribution</p>
                    </div>
                  </div>
                </div>
                <div className="col col-12 col-lg-4">
                  <div className="thumbnail">
                    <img src={pipelines_distribution} alt="Distribution" />
                    <div className="text">
                      <h2>Distribution</h2>
                      <p>Deliver natural gas to people's homes or businesses</p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-alt">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="text-center">
                    <img src={pipelines_circle} alt="Warning image" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col text-center">
                  <a id="markerBtn" href="/markers" onClick={ e => { e.preventDefault(); this.props.history.push('/markers');} } className="btn btn-warning">Marker Examples and Colors</a>
                </div>
              </div>
            </div>
          </div>
          <div className="row stats-section">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h1 className="text-center">Prevention Measures</h1>
                  <p className="text-center">The time and investment ncessary to protect the operational performance and integrity of underground infrastructure is similar to a homeowner wanting to protect and maintain the value associated with their home.</p>
                </div>
              </div>
              <div className="row">
                <div className="container link-container">
                  <div className="row">
                    <div className="col text-center">
                      <a href="/leak-recognition" onClick={ e => { e.preventDefault(); this.props.history.push('/leak-recognition');} }>
                        <img src={pipelines_leak} height="250px" />
                      </a>
                    </div>
                    <div className="col text-center">
                      <a href="/leak-response" onClick={ e => { e.preventDefault(); this.props.history.push('/leak-response');} }>
                        <img src={pipelines_leak_response} height="250px" />
                      </a>
                    </div>
                    <div className="col-12 text-center">
                      <a id="markerBtn" href="/damage-reporting" onClick={ e => { e.preventDefault(); this.props.history.push('/damage-reporting');} } className="btn btn-warning">Damage Prevention Reporting</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row resourceRow">
            <div className="col info">
              <h1>Resource Links:</h1>
              <ul>
                <li><a href="http://www.aga.org" target="_blank">aga.org</a></li>
                <li><a href="http://www.api.org" target="_blank">api.org</a></li>
                <li><a href="http://www.apga.org" target="_blank">apga.org</a></li>
                <li><a href="http://www.aopl.org" target="_blank">aopl.org</a></li>
                <li><a href="http://www.ingaa.org" target="_blank">ingaa.org</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UgiPipelinesPage.propTypes = {};

export default UgiPipelinesPage;



// WEBPACK FOOTER //
// ./src/components/pages/ugiPipelines/UgiPipelinesPage.js